import { makeActionCreator } from '../redux-util/general-helpers';
import { getAllClasses } from './known-class-selectors';
import moment from 'moment';

export const ADD = 'known-classes.add';
export const REMOVE = 'known-classes.remove';

const addOrUpdateClassObj = makeActionCreator(ADD, 'code', 'name');

export function addOrUpdateClass(code, name) {
  return function(dispatch) {
    dispatch(addOrUpdateClassObj(code, name));
  };
}

export const removeClass = makeActionCreator(REMOVE, 'code');

export function removeExpiredClasses() {
  return function(dispatch, getState) {
    const classes = getAllClasses(getState());
    classes.forEach(c => {
      if (moment(c.expires).isBefore(moment())) {
        dispatch(removeClass(c.code));
      }
    });
  };
}
